import React, {
    useEffect,
    useState
} from 'react';

import Modal from 'react-modal';

import {
    ModalEconomiaContenido,
    ModalEconomiaCabecera,
    ModalEconomiaTitulo,
    BotonCerrarModal,

    ModalSeccion,
    ModalSeccionTitulo,
    ModalAcciones,
    ModalScrollContenido,

    BotonPrincipal,
    BotonSecundario,

    CobroFormulario,
    CobroCamposGrid,
    CobroCampo,
    CobroLabel,
    CobroInput,
    CobroSelect,
    CobroTextarea
} from '../../Css/StyledEstadisticasCobros.js';


Modal.setAppElement(
    '#root'
);


/*
====================================
FECHA DE HOY
====================================
*/

const getFechaHoy = () => {

    const hoy =
        new Date();


    const year =
        hoy.getFullYear();


    const month =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            '0'
        );


    const day =
        String(
            hoy.getDate()
        ).padStart(
            2,
            '0'
        );


    return `${year}-${month}-${day}`;

};


/*
====================================
DINERO
====================================
*/

const formatMoney = (
    value
) => {

    return new Intl.NumberFormat(
        'es-AR',
        {
            style:
                'currency',

            currency:
                'ARS',

            maximumFractionDigits:
                2
        }
    ).format(
        Number(
            value ||
            0
        )
    );

};


/*
====================================
MODAL
====================================
*/

const PagoCentroModal = ({

    isOpen,

    onClose,

    centro,

    posicion,

    onGuardar,

    guardando

}) => {


    const [
        fechaPago,
        setFechaPago
    ] = useState(
        getFechaHoy()
    );


    const [
        importe,
        setImporte
    ] = useState(
        ''
    );


    const [
        medioPago,
        setMedioPago
    ] = useState(
        'TRANSFERENCIA'
    );


    const [
        referencia,
        setReferencia
    ] = useState(
        ''
    );


    const [
        concepto,
        setConcepto
    ] = useState(
        ''
    );


    const [
        observacion,
        setObservacion
    ] = useState(
        ''
    );


    const [
        errorFormulario,
        setErrorFormulario
    ] = useState(
        ''
    );


    /*
    ====================================
    REINICIAR
    ====================================
    */

    useEffect(() => {

        if (
            !isOpen
        ) {

            return;

        }


        setFechaPago(
            getFechaHoy()
        );


        setImporte(
            ''
        );


        setMedioPago(
            'TRANSFERENCIA'
        );


        setReferencia(
            ''
        );


        setConcepto(
            ''
        );


        setObservacion(
            ''
        );


        setErrorFormulario(
            ''
        );

    }, [
        isOpen
    ]);


    /*
    ====================================
    CAMBIAR IMPORTE
    ====================================
    */

    const handleImporte = (
        e
    ) => {

        const valor =
            e.target.value;


        if (
            valor === '' ||
            /^\d*(?:[.,]\d{0,2})?$/
                .test(
                    valor
                )
        ) {

            setImporte(
                valor
            );


            setErrorFormulario(
                ''
            );

        }

    };


    /*
    ====================================
    GUARDAR
    ====================================
    */

    const handleGuardar =
        async () => {

            setErrorFormulario(
                ''
            );


            if (
                guardando
            ) {

                return;

            }


            if (
                !centro?.id
            ) {

                setErrorFormulario(
                    'No se pudo identificar el centro.'
                );

                return;

            }


            if (
                !fechaPago
            ) {

                setErrorFormulario(
                    'Indicá la fecha del pago.'
                );

                return;

            }


            const importeNumero =
                Number(
                    String(
                        importe
                    )
                        .replace(
                            ',',
                            '.'
                        )
                );


            if (
                !Number.isFinite(
                    importeNumero
                ) ||
                importeNumero <=
                    0
            ) {

                setErrorFormulario(
                    'Ingresá un importe mayor a 0.'
                );

                return;

            }


            if (
                typeof onGuardar !==
                    'function'
            ) {

                return;

            }


            const resultado =
                await onGuardar({

                    centro_id:
                        centro.id,

                    fecha_pago:
                        fechaPago,

                    importe:
                        importeNumero,

                    moneda:
                        'ARS',

                    medio_pago:
                        medioPago ||
                        null,

                    referencia_externa:
                        referencia
                            .trim() ||
                        null,

                    concepto:
                        concepto
                            .trim() ||
                        null,

                    observacion:
                        observacion
                            .trim() ||
                        null,

                    origen_pago:
                        'MANUAL'

                });


            if (
                resultado?.ok ===
                    false
            ) {

                setErrorFormulario(
                    resultado.msg ||
                    'No se pudo registrar el pago.'
                );

            }

        };


    /*
    ====================================
    CERRAR
    ====================================
    */

    const handleCerrar = () => {

        if (
            guardando
        ) {

            return;

        }


        onClose();

    };


    return (

        <Modal

            isOpen={
                isOpen
            }

            onRequestClose={
                handleCerrar
            }

            shouldCloseOnOverlayClick={
                !guardando
            }

            shouldCloseOnEsc={
                !guardando
            }

            style={{

                overlay: {

                    zIndex:
                        2000,

                    backgroundColor:
                        'rgba(0, 0, 0, 0.45)',

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    padding:
                        '1rem'

                },

                content: {

                    position:
                        'relative',

                    inset:
                        'auto',

                    border:
                        'none',

                    background:
                        'transparent',

                    padding:
                        0,

                    width:
                        '94vw',

                    maxWidth:
                        '820px',

                    maxHeight:
                        '92vh',

                    overflow:
                        'hidden'

                }

            }}
        >

            <ModalEconomiaContenido

                style={{

                    width:
                        '100%',

                    maxWidth:
                        'none',

                    height:
                        'auto',

                    maxHeight:
                        '90vh',

                    display:
                        'flex',

                    flexDirection:
                        'column',

                    overflow:
                        'hidden'

                }}
            >


                {/*
                ====================================
                CABECERA FIJA
                ====================================
                */}

                <ModalEconomiaCabecera
                    style={{
                        flexShrink:
                            0
                    }}
                >

                    <div>

                        <ModalEconomiaTitulo>

                            Registrar pago al centro

                            <span
                                style={{

                                    fontWeight:
                                        500,

                                    color:
                                        '#647171'

                                }}
                            >
                                {' — '}

                                {
                                    centro
                                        ?.nombre ||
                                    'Centro'
                                }

                            </span>

                        </ModalEconomiaTitulo>

                    </div>


                    <BotonCerrarModal

                        type="button"

                        onClick={
                            handleCerrar
                        }

                        disabled={
                            guardando
                        }
                    >
                        ×
                    </BotonCerrarModal>

                </ModalEconomiaCabecera>


                {/*
                ====================================
                CONTENIDO SCROLLEABLE
                ====================================
                */}

                <ModalScrollContenido

                    style={{

                        flex:
                            '1 1 auto',

                        minHeight:
                            0,

                        maxHeight:
                            'none',

                        overflowY:
                            'auto',

                        overflowX:
                            'hidden',

                        paddingBottom:
                            '0.5rem'

                    }}
                >

                    <CobroFormulario>


                        {/*
                        ====================================
                        POSICIÓN ACTUAL
                        ====================================
                        */}

                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Posición actual
                            </ModalSeccionTitulo>


                            <div
                                style={{

                                    display:
                                        'flex',

                                    alignItems:
                                        'center',

                                    flexWrap:
                                        'wrap',

                                    gap:
                                        '0.45rem 1.6rem',

                                    padding:
                                        '0.75rem 0.85rem',

                                    borderRadius:
                                        '8px',

                                    backgroundColor:
                                        '#F5FAFA',

                                    fontSize:
                                        '0.78rem',

                                    lineHeight:
                                        1.5

                                }}
                            >

                                <div>

                                    Pendiente neto:

                                    {' '}

                                    <strong>

                                        {
                                            formatMoney(
                                                posicion
                                                    ?.saldo_neto_pendiente
                                            )
                                        }

                                    </strong>

                                </div>


                                {
                                    Number(
                                        posicion
                                            ?.saldo_a_favor ||
                                        0
                                    ) >
                                    0

                                        ? (

                                            <div>

                                                Saldo a favor:

                                                {' '}

                                                <strong>

                                                    {
                                                        formatMoney(
                                                            posicion
                                                                ?.saldo_a_favor
                                                        )
                                                    }

                                                </strong>

                                            </div>

                                        )

                                        : null
                                }


                                {
                                    Number(
                                        posicion
                                            ?.pagos_sin_aplicar ||
                                        0
                                    ) >
                                    0

                                        ? (

                                            <div>

                                                Pagos sin aplicar:

                                                {' '}

                                                <strong>

                                                    {
                                                        formatMoney(
                                                            posicion
                                                                ?.pagos_sin_aplicar
                                                        )
                                                    }

                                                </strong>

                                            </div>

                                        )

                                        : null
                                }

                            </div>

                        </ModalSeccion>


                        {/*
                        ====================================
                        PAGO
                        ====================================
                        */}

                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Pago
                            </ModalSeccionTitulo>


                            <CobroCamposGrid>


                                <CobroCampo>

                                    <CobroLabel>
                                        Fecha de pago *
                                    </CobroLabel>


                                    <CobroInput

                                        type="date"

                                        value={
                                            fechaPago
                                        }

                                        onChange={(e) =>
                                            setFechaPago(
                                                e.target.value
                                            )
                                        }

                                        disabled={
                                            guardando
                                        }
                                    />

                                </CobroCampo>


                                <CobroCampo>

                                    <CobroLabel>
                                        Importe *
                                    </CobroLabel>


                                    <CobroInput

                                        type="text"

                                        inputMode="decimal"

                                        value={
                                            importe
                                        }

                                        onChange={
                                            handleImporte
                                        }

                                        placeholder="0,00"

                                        disabled={
                                            guardando
                                        }
                                    />

                                </CobroCampo>


                                <CobroCampo>

                                    <CobroLabel>
                                        Medio de pago
                                    </CobroLabel>


                                    <CobroSelect

                                        value={
                                            medioPago
                                        }

                                        onChange={(e) =>
                                            setMedioPago(
                                                e.target.value
                                            )
                                        }

                                        disabled={
                                            guardando
                                        }
                                    >

                                        <option value="TRANSFERENCIA">
                                            Transferencia
                                        </option>

                                        <option value="EFECTIVO">
                                            Efectivo
                                        </option>

                                        <option value="MERCADO_PAGO">
                                            Mercado Pago
                                        </option>

                                        <option value="OTRO">
                                            Otro
                                        </option>

                                    </CobroSelect>

                                </CobroCampo>


                                <CobroCampo>

                                    <CobroLabel>
                                        Referencia
                                    </CobroLabel>


                                    <CobroInput

                                        type="text"

                                        value={
                                            referencia
                                        }

                                        onChange={(e) =>
                                            setReferencia(
                                                e.target.value
                                            )
                                        }

                                        maxLength={
                                            150
                                        }

                                        placeholder="Opcional"

                                        disabled={
                                            guardando
                                        }
                                    />

                                </CobroCampo>

                            </CobroCamposGrid>


                            <CobroCampo
                                style={{

                                    marginTop:
                                        '0.8rem'

                                }}
                            >

                                <CobroLabel>
                                    Concepto
                                </CobroLabel>


                                <CobroInput

                                    type="text"

                                    value={
                                        concepto
                                    }

                                    onChange={(e) =>
                                        setConcepto(
                                            e.target.value
                                        )
                                    }

                                    maxLength={
                                        255
                                    }

                                    placeholder="Opcional"

                                    disabled={
                                        guardando
                                    }
                                />

                            </CobroCampo>


                            <CobroCampo
                                style={{

                                    marginTop:
                                        '0.8rem'

                                }}
                            >

                                <CobroLabel>
                                    Observación
                                </CobroLabel>


                                <CobroTextarea

                                    value={
                                        observacion
                                    }

                                    onChange={(e) =>
                                        setObservacion(
                                            e.target.value
                                        )
                                    }

                                    maxLength={
                                        500
                                    }

                                    placeholder="Opcional"

                                    disabled={
                                        guardando
                                    }

                                    style={{

                                        minHeight:
                                            '65px'

                                    }}
                                />

                            </CobroCampo>

                        </ModalSeccion>


                        {/*
                        ====================================
                        ERROR
                        ====================================
                        */}

                        {
                            errorFormulario

                                ? (

                                    <div
                                        style={{

                                            marginTop:
                                                '0.8rem',

                                            color:
                                                '#C94B55',

                                            fontSize:
                                                '0.78rem',

                                            fontWeight:
                                                600

                                        }}
                                    >

                                        {
                                            errorFormulario
                                        }

                                    </div>

                                )

                                : null
                        }

                    </CobroFormulario>

                </ModalScrollContenido>


                {/*
                ====================================
                ACCIONES FIJAS
                ====================================
                */}

                <ModalAcciones

                    style={{

                        flexShrink:
                            0,

                        marginTop:
                            0,

                        paddingTop:
                            '0.85rem',

                        borderTop:
                            '1px solid #E3E9E8',

                        backgroundColor:
                            '#FFFFFF'

                    }}
                >

                    <BotonSecundario

                        type="button"

                        onClick={
                            handleCerrar
                        }

                        disabled={
                            guardando
                        }
                    >
                        Cancelar
                    </BotonSecundario>


                    <BotonPrincipal

                        type="button"

                        onClick={
                            handleGuardar
                        }

                        disabled={
                            guardando
                        }
                    >

                        {
                            guardando

                                ? 'Registrando...'

                                : 'Registrar pago'
                        }

                    </BotonPrincipal>

                </ModalAcciones>

            </ModalEconomiaContenido>

        </Modal>

    );

};


export default PagoCentroModal;